import { defineStore } from 'pinia'
import { ref } from 'vue'
import { storageLike } from "@/store/pinia.js"

export const tokenStore = defineStore('accessToken', () => {
    const token = ref('');
    const refuseToken = ref('');

    const setToken = (val) => {
        token.value = val?.token;
        refuseToken.value = val?.refuseToken;
    }
    const getToken = () => {
        return token.value;
    }
    const getRefuseToken = () => {
        return refuseToken.value;
    }
    const removeToken = () => {
        return new Promise(resolve => {
            token.value = '';
            refuseToken.value = '';
            resolve()
        })
    }
    return {
        token,
        refuseToken,
        setToken,
        getToken,
        getRefuseToken,
        removeToken
    }
}, {
    persist: {
        storage: storageLike
    },
})